import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../auth/AuthProvider";
import { demoIncentivesRepository } from "./demoIncentivesRepository";
import { remoteIncentivesRepository } from "./remoteIncentivesRepository";
import { env } from "../../shared/config/env";
const key = ["v4-incentives"];
const repository = (env.VITE_AUTH_MODE === "supabase"
  ? remoteIncentivesRepository
  : demoIncentivesRepository) as unknown as typeof demoIncentivesRepository;
export function useIncentives() {
  return useQuery({ queryKey: key, queryFn: () => repository.getState() });
}
export function useIncentiveActions() {
  const { session } = useAuth(),
    client = useQueryClient(),
    actor = () => {
      if (!session) throw new Error("请先登录。");
      return session.profile;
    },
    refresh = () => client.invalidateQueries({ queryKey: key });
  const claim = useMutation({
    mutationFn: (
      input: Parameters<typeof demoIncentivesRepository.submitClaim>[1],
    ) => repository.submitClaim(actor(), input),
    onSuccess: refresh,
  });
  const review = useMutation({
    mutationFn: (
      input: Parameters<typeof demoIncentivesRepository.reviewClaim>[1],
    ) => repository.reviewClaim(actor(), input),
    onSuccess: refresh,
  });
  const appeal = useMutation({
    mutationFn: (
      input: Parameters<typeof demoIncentivesRepository.submitAppeal>[1],
    ) => repository.submitAppeal(actor(), input),
    onSuccess: refresh,
  });
  const appealReview = useMutation({
    mutationFn: (
      input: Parameters<typeof demoIncentivesRepository.reviewAppeal>[1],
    ) => repository.reviewAppeal(actor(), input),
    onSuccess: refresh,
  });
  const rule = useMutation({
    mutationFn: (
      input: Parameters<typeof demoIncentivesRepository.createRule>[1],
    ) => repository.createRule(actor(), input),
    onSuccess: refresh,
  });
  const adjust = useMutation({
    mutationFn: (
      input: Parameters<typeof demoIncentivesRepository.adjust>[1],
    ) => repository.adjust(actor(), input),
    onSuccess: refresh,
  });
  const honor = useMutation({ mutationFn: (input: Parameters<typeof demoIncentivesRepository.awardHonor>[1]) => repository.awardHonor(actor(), input), onSuccess: refresh });
  const clearing = useMutation({ mutationFn: (input: Parameters<typeof demoIncentivesRepository.runAnnualClearing>[1]) => repository.runAnnualClearing(actor(), input), onSuccess: refresh });
  return {
    submitClaim: claim.mutateAsync,
    reviewClaim: review.mutateAsync,
    submitAppeal: appeal.mutateAsync,
    reviewAppeal: appealReview.mutateAsync,
    createRule: rule.mutateAsync,
    adjust: adjust.mutateAsync,
    awardHonor: honor.mutateAsync,
    runAnnualClearing: clearing.mutateAsync,
    pending:
      claim.isPending ||
      review.isPending ||
      appeal.isPending ||
      appealReview.isPending ||
      rule.isPending ||
      adjust.isPending || honor.isPending || clearing.isPending,
  };
}
